<template>
  <v-container fluid class="nsr-item" v-if="rbu_item" style="zoom: 85%">
    <div class="fixed-nsr-header">
      <v-btn
        text
        color="primary"
        exact
        :to="{
          name: 'a-sor-rbu-section',
          params: { aSorId: a_sor_id },
        }"
      >
        &lt;&lt; a-sor item
      </v-btn>
      <div>
        <v-btn
          v-if="a_sor && !a_sor.finalised_at"
          color="primary"
          style="margin-right: 1rem"
          @click="save"
          >Save <span v-if="isChanged">*</span></v-btn
        >

        <v-btn
          v-if="a_sor"
          color="primary"
          style="margin-right: 8rem"
          @click="exportPDF"
          >Export PDF
        </v-btn>
      </div>
    </div>

    <!-- ITEM NO. -->
    <v-row style="margin-top: 1.2rem">
      <div class="nsr-item-no">
        <v-text-field
          filled
          readonly
          label="Item No."
          hide-details="auto"
          style="max-width: 20rem"
          v-model="rbu_item.dummy_item_no"
        ></v-text-field>
      </div>
    </v-row>

    <!-- DESCRIPTION -->
    <v-row>
      <div class="a-sor-item-description-wrapper">
        <label>Descriptions</label>
        <div class="a-sor-item-descriptions">
          <div class="a-sor-item-description-row">
            <div class="a-sor-item-description-title">Work Nature</div>
            <div class="a-sor-item-description-content">
              {{ rbu_item.printed_remarks }}
            </div>
          </div>
          <div class="a-sor-item-description-row">
            <div class="a-sor-item-description-title">Action Description</div>
            <div
              class="a-sor-item-description-content"
              v-html="rbu_item.printed_description"
            ></div>
          </div>
          <div class="a-sor-item-description-row">
            <div class="a-sor-item-description-title">Rate Range</div>
            <div
              class="a-sor-item-description-content"
              v-html="rbu_item.unit_desc"
            ></div>
          </div>

          <div class="a-sor-item-description-row">
            <div class="a-sor-item-description-title">Unit</div>
            <div
              class="a-sor-item-description-content"
              v-html="rbu_item.unit"
            ></div>
          </div>
        </div>
      </div>
    </v-row>

    <!-- REMARK -->
    <v-row>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 1rem;
          margin-top: 1rem;
        "
      >
        <span style="width: 7rem">Remarks</span>
        <v-textarea
          outlined
          auto-grow
          rows="1"
          dense
          hide-details
          placeholder="Item Remark"
          style="min-width: 20rem"
          :value="rbu_item.item_remark"
          @input="onItemUpdate({ item_remark: $event })"
        ></v-textarea>
      </div>
    </v-row>

    <!-- Adopted Rate -->
    <v-row>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 1rem;
          margin-top: 1rem;
        "
      >
        <span style="width: 7rem">Rounding</span>
        <v-select
          outlined
          hide-details
          attach
          placeholder="Rounding"
          :items="roundingOptions"
          :value="rbu_item.rounding"
          @input="onItemUpdate({ rounding: $event })"
        ></v-select>
      </div>
    </v-row>

    <v-row>
      <div class="nsr-item-calculated-rate">
        <div class="nsr-item-calculated-rate-grid">
          <div></div>
          <div>
            <span class="nsr-item-calculated-rate-title">Calculated Rate</span>
          </div>
          <div>
            <span class="nsr-item-calculated-rate-title">Original</span>
          </div>
          <div>
            {{ $parseCurrency(rbu_item.value) }}
          </div>
          <div><span class="nsr-item-calculated-rate-title">Rounded</span></div>
          <div>{{ roundedValue }}</div>
        </div>
      </div>
    </v-row>

    <!-- Editor -->
    <v-row>
      <ASorRbuEditor
        :aSor="a_sor"
        :rbuItem="rbu_item"
        @update="onItemUpdate"
      ></ASorRbuEditor>
    </v-row>
  </v-container>
</template>

<script>
import { ref, onMounted, computed, watch, provide } from "@vue/composition-api";
import { isEqual } from "lodash";
import { ACTION_TYPES } from "@/store/types";
import RbuItemAdoptedRate from "@/components/rbu/RbuItemAdoptedRate.vue";
import ASorRbuEditor from "@/components/asor/ASorRbuEditor.vue";

export default {
  name: "AsorRbuItem",
  components: { RbuItemAdoptedRate, ASorRbuEditor },
  beforeRouteLeave(to, from, next) {
    console.log(this.a_sor.finalised_at);
    if (this.a_sor && this.a_sor.finalised_at) {
      next();
    } else if (this.isChanged) {
      const answer = window.confirm(
        "There is unsaved changes, are you sure to leave?"
      );
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  setup(props, { root }) {
    const a_sor_id = ref(root.$route.params.aSorId);
    const a_sor = ref(null);
    const rbu_item = ref(null);
    provide(
      "ASOR_RBU_DATASET",
      computed(() => {
        return a_sor.value ? a_sor.value.selected_dataset : null;
      })
    );

    let cloneItem = null;
    const isChanged = ref(false);
    const roundingOptions = ref([
      { text: "Round to 0.01", value: "0.01" },
      { text: "Round to 0.1", value: "0.10" },
      { text: "Round to 1", value: "1.00" },
      { text: "Round to 10", value: "10.00" },
      { text: "Round to 100", value: "100.00" },
      { text: "Round to 1000", value: "1000.00" },
    ]);

    const roundedValue = computed(() => {
      if (!rbu_item.value || !rbu_item.value.rounding)
        return "$" + nsrItem.value.value || "$0";

      try {
        return root.$parseCurrency(
          rbu_item.value.calculated_rate,
          rbu_item.value.rounding
        );
      } catch (e) {
        console.log(e);
        return "$0";
      }
    });

    const getASoRItem = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/contract/a_sor/a_sor_item/",
        params: {
          rbu_item_id: root.$route.params.rbuItemId,
          a_sor_id: a_sor.value.id,
        },
      });

      if (response.body.success) {
        rbu_item.value = response.body.rbu_item;

        if (!rbu_item.value.adjustment_percentage_formula) {
          rbu_item.value.adjustment_percentage = 100;
        }

        if (!rbu_item.value.adjustment_value_formula) {
          rbu_item.value.adjustment_value = 0;
        }

        if (!rbu_item.value.rounding) {
          rbu_item.value.rounding = "0.1";
        }

        // init unit for old items if null
        if (rbu_item.value) {
          for (const module_group of rbu_item.value.module_groups) {
            for (const module of module_group.modules) {
              if (!module.tender_rate_unit) {
                module.tender_rate_unit = rbu_item.value.unit;
              }
              if (!module.datapoint_unit) {
                module.datapoint_unit = rbu_item.value.unit;
              }
            }
          }
        }

        cloneItem = JSON.parse(JSON.stringify(rbu_item.value));
        isChanged.value = false; // Reset
      }
    };

    const getASor = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/contract/a_sor/",
        params: { a_sor_id: root.$route.params.aSorId },
      });

      if (response.body.success) {
        a_sor.value = response.body.a_sor;
      }
    };

    const save = async function () {
      async function processDatapoint(datapoint) {
        const file = datapoint.file
          ? datapoint.file instanceof File
            ? await root.$convertFileToBase64(datapoint.file)
            : datapoint.file.id
          : null;
        const filename = datapoint.file
          ? datapoint.file instanceof File
            ? datapoint.file.name
            : null
          : null;

        return {
          ...datapoint,
          file,
          filename,
        };
      }

      async function processTenderRates(tender_rate) {
        const file = tender_rate.file
          ? tender_rate.file instanceof File
            ? await root.$convertFileToBase64(tender_rate.file)
            : tender_rate.file.id
          : null;
        const filename = tender_rate.file
          ? tender_rate.file instanceof File
            ? tender_rate.file.name
            : null
          : null;

        return {
          ...tender_rate,
          file,
          filename,
        };
      }

      async function processFluctuation(fluctuation) {
        const file = fluctuation.file
          ? fluctuation.file instanceof File
            ? await root.$convertFileToBase64(fluctuation.file)
            : fluctuation.file.id
          : null;
        const filename = fluctuation.file
          ? fluctuation.file instanceof File
            ? fluctuation.file.name
            : null
          : null;

        return {
          ...fluctuation,
          previous_dataset: fluctuation.previous_datapoint
            ? fluctuation.previous_datapoint.dataset.id
            : null,
          previous_datapoint: fluctuation.previous_datapoint
            ? fluctuation.previous_datapoint.id
            : null,
          current_dataset: fluctuation.current_datapoint
            ? fluctuation.current_datapoint.dataset.id
            : null,
          current_datapoint: fluctuation.current_datapoint
            ? fluctuation.current_datapoint.id
            : null,
          file,
          filename,
        };
      }

      async function processModule(module) {
        const tender_rates = await Promise.all(
          (module.tender_rates || []).map(processTenderRates)
        );
        const datapoints = await Promise.all(
          (module.datapoints || []).map(processDatapoint)
        );
        const fluctuations = await Promise.all(
          (module.fluctuations || []).map(processFluctuation)
        );

        return {
          ...module,
          tender_rates,
          datapoints,
          fluctuations,
        };
      }

      async function processModuleGroup(module_group) {
        const modules = await Promise.all(
          module_group.modules.map(processModule)
        );

        return {
          ...module_group,
          modules,
        };
      }

      function numberToAlphabet(num) {
        let result = "";
        while (num >= 0) {
          let remainder = num % 26;
          result = String.fromCharCode(65 + remainder) + result;
          num = Math.floor(num / 26) - 1;
        }
        return result;
      }

      const module_groups = await Promise.all(
        rbu_item.value.module_groups.map(processModuleGroup)
      );

      let miss_unit = false;
      let miss_unit_error_msg = "";
      let miss_portion = false;
      let miss_portion_error_msg = "";
      let miss_census_rate = false;
      let miss_census_rate_error_msg = "";

      if (!rbu_item.value.adjustment_percentage_formula) {
        rbu_item.value.adjustment_percentage_formula = "";
        rbu_item.value.adjustment_percentage = "100";
      }

      if (!rbu_item.value.adjustment_value_formula) {
        rbu_item.value.adjustment_value_formula = "";
        rbu_item.value.adjustment_value = "0";
      }

      for (let i = 0; i < module_groups.length; i++) {
        const group = module_groups[i];
        if (!group.name) {
          // group.name = `Group ${numberToAlphabet(i)}`;
          group.name = "";
        }

        if (!group.adjustment_value_formula) {
          group.adjustment_value_formula = "";
          group.adjustment_value = "0";
        }

        if (!group.adjustment_percentage_formula) {
          group.adjustment_percentage_formula = "";
          group.adjustment_percentage = "100";
        }

        for (let j = 0; j < group.modules.length; j++) {
          const module = group.modules[j];
          if (!module.name) {
            // module.name = `Module ${numberToAlphabet(j)}`;
            module.name = "";
          }

          // check potion missing
          if (!module.portion) {
            miss_portion = true;
            miss_portion_error_msg += `Please fill in the Portion for Group ${numberToAlphabet(
              group.order_no
            )} - Module ${numberToAlphabet(module.order_no)} \n`;
          }

          // check adjustment_value_formula
          if (!module.adjustment_value_formula) {
            module.adjustment_value_formula = "";
            module.adjustment_value = "0";
          }

          //check adjustment_percentage_formula
          if (!module.adjustment_percentage_formula) {
            module.adjustment_percentage_formula = "";
            module.adjustment_percentage = "100";
          }

          if (
            module.base_rate_type === "TENDER_RATES" &&
            !module.tender_rate_unit
          ) {
            miss_unit = true;
            miss_unit_error_msg += `Please fill in the Unit for Tender Rates in Group ${numberToAlphabet(
              group.order_no
            )} - Module ${numberToAlphabet(module.order_no)} \n`;
          }

          if (module.base_rate_type === "DATAPOINT" && !module.datapoint_unit) {
            miss_unit = true;
            miss_unit_error_msg += `Please fill in the Unit for C&S cost data in Group ${numberToAlphabet(
              group.order_no
            )} - Module ${numberToAlphabet(module.order_no)} \n`;
          }

          for (const f of module.fluctuations) {
            if (!f.current_datapoint || !f.previous_datapoint) {
              miss_census_rate = true;
              miss_census_rate_error_msg += `Please complete the fluctuation census data in Group ${numberToAlphabet(
                group.order_no
              )} - Module ${numberToAlphabet(module.order_no)} \n`;
            }
          }
        }
      }

      if (miss_unit) {
        alert(miss_unit_error_msg);
        return;
      }

      if (miss_portion) {
        alert(miss_portion_error_msg);
        return;
      }

      if (miss_census_rate) {
        alert(miss_census_rate_error_msg);
        return;
      }

      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/contract/a_sor/edit_rbu_item/",
        params: {
          a_sor_id: a_sor.value.id,
          rbu_item_id: rbu_item.value.id,
          rbu_item: { ...rbu_item.value },
          rbu_item_module_groups: module_groups,
        },
      });

      if (response.body.success) {
        getASoRItem();
      }
    };

    const onItemUpdate = function (evt) {
      // console.log(evt);

      rbu_item.value = {
        ...rbu_item.value,
        ...evt,
      };
    };

    function getDifferences(obj1, obj2, path = "") {
      if (path === ".beforeAdjustments") return;
      if (typeof obj1 !== "object" || obj1 === null) {
        if (obj1 != obj2) {
          console.debug(`Difference at ${path}:`, {
            original: obj1,
            current: obj2,
          });
          isChanged.value = true;
        }
      } else if (obj1 !== null && obj2 !== null) {
        Object.keys(obj1).forEach((key) => {
          if (key !== "beforeAdjustments" && !obj2.hasOwnProperty(key)) {
            console.debug(`Key '${key}' missing in obj2 at ${path}`);
            isChanged.value = true;
          } else {
            getDifferences(obj1[key], obj2[key], `${path}.${key}`);
          }
        });

        Object.keys(obj2).forEach((key) => {
          if (key !== "beforeAdjustments" && !obj1.hasOwnProperty(key)) {
            isChanged.value = true;
            console.debug(`Key '${key}' missing in obj1 at ${path}`);
          }
        });
      }
    }

    const exportPDF = async () => {
      await save();
      let response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/contract/a_sor/generate_rbu_page_pdf/",
        params: {
          item_id: rbu_item.value.id,
          a_sor_id: a_sor.value.id,
        },
        opt: { extra: { responseType: "arraybuffer" } },
      });

      let blob = new Blob([response.data], {
        type: response.headers.get("content-type"),
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = decodeURI(response.headers.get("content-filename"));
      link.click();
    };
    watch(
      rbu_item,
      (newValue) => {
        isChanged.value = false;
        getDifferences(newValue, cloneItem);
      },
      { deep: true }
    );

    watch(
      () => root.$route.params.rbuItemId,
      async (newValue) => {
        await getASor();
        getASoRItem();
      },
      { immediate: true }
    );

    return {
      roundingOptions,
      roundedValue,
      save,
      onItemUpdate,
      isChanged,
      rbu_item,
      a_sor_id,
      a_sor,
      exportPDF,
    };
  },
};
</script>

<style lang="scss">
.nsr-item {
  width: 100%;
  //   height: 100%;
  //   display: flex;
  //   flex-direction: column;
  .fixed-nsr-header {
    position: fixed;
    top: 5rem;
    left: 5rem;
    padding-top: 1rem;
    display: flex;
    justify-content: space-between;
    width: 100%;
    background-color: #efeeee;
    z-index: 10; /* Adjust as needed */
  }
}

.nsr-item-no {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
  margin-top: 1rem;
}

.nsr-item-calculated-rate {
  margin-top: 1rem;
  padding: 1rem;
  width: 30rem;
  background-color: white;
  border-radius: 0.5rem;
  border: 1px solid var(--v-primary-base);

  .nsr-item-calculated-rate-grid {
    display: grid;
    gap: 1px;
    grid-template-columns: repeat(2, 1fr);

    div {
      padding: 0.5rem;

      .nsr-item-calculated-rate-title {
        color: rgba(0, 0, 0, 0.4);
      }
    }
  }
}

.nsr-item-description-wrapper {
  margin-top: 16px;
  width: 100%;

  .nsr-item-descriptions {
    margin-top: 0.75rem;
    padding: 16px;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 8px;

    .nsr-item-description-row {
      display: flex;
      padding: 4px;
      align-items: center;

      .nsr-item-description-title {
        flex: 0 0 auto;
        color: rgba(0, 0, 0, 0.4);
        margin-right: 12px;
        width: 14rem;
      }

      .nsr-item-description-content {
        flex: 1 1 0;
      }
    }
  }
}
</style>

<style scoped>
::v-deep .v-input__slot::before {
  border-style: none !important;
}
</style>
<style lang="scss">
.a-sor-item-description-wrapper {
  margin-top: 16px;
  width: 100%;

  .a-sor-item-descriptions {
    margin-top: 0.75rem;
    padding: 16px;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 8px;

    .a-sor-item-description-row {
      display: flex;
      padding: 4px;
      align-items: center;

      .a-sor-item-description-title {
        flex: 0 0 auto;
        color: rgba(0, 0, 0, 0.4);
        margin-right: 12px;
        width: 14rem;
      }

      .a-sor-item-description-content {
        flex: 1 1 0;
      }
    }
  }
}
</style>
